import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class Trigger extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    active: PropTypes.bool,
    linkTo: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
      replace: PropTypes.func.isRequired,
    }).isRequired,
  };

  handleOnClick = () => {
    const { linkTo } = this.props;
    this.props.history.push(linkTo);
  };

  render() {
    const { children, active, linkTo, onMouseEnter, onMouseLeave } = this.props;

    return (
      <span
        className={classnames('nav-link', 'menu-link', 'a-tab-bar-item', { active })}
        onClick={linkTo ? this.handleOnClick : null}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </span>
    );
  }
}

export default withRouter(Trigger);
